import { render, staticRenderFns } from "./ineligible.vue?vue&type=template&id=9d49aac6&"
import script from "./ineligible.vue?vue&type=script&lang=js&"
export * from "./ineligible.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports